var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"web-honor",style:({
    backgroundImage: 'url(' + _vm.dataInfo.cover + ')'
  }),on:{"click":_vm.toDetail}})
}
var staticRenderFns = []

export { render, staticRenderFns }